import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const products = 'Products'

export const getProducts = (filters) => {
  return axios.post(`/${products}/PaginatedAndFiltered`, filters)
}

export const getProduct = (id) => {
  return axios.get(`/${products}/${id}`)
}
